import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { useSelector } from 'react-redux';

import { Badge, Space, Typography } from '@sravni/react-design-system';
import { Message } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import { LIST_BY_RUBRICS } from '../../constants/routes';
import { getMaterialLink } from '../../helpers/news';
import { trimHtml } from '../../helpers/trimHtml';
import { IHighlightedMaterial } from '../../interfaces/news';
import { getLatestNews } from '../../selectors/news';
import { createLinkProps } from '../../utils/routing';

import styles from './news-block.module.scss';

interface Props {
  className?: string;
}

const renderInfoBlock = (news: IHighlightedMaterial) => {
  return (
    <span className={styles.infoItemWrapper}>
      {news.commentsCount > 0 && news.canCreateNewComments && (
        <Typography.Text size={12} className={styles.infoItem}>
          <Message className={styles.infoItemIcon} /> {news.commentsCount}
        </Typography.Text>
      )}
      {/*{!!news.likes && (*/}
      {/*  <Typography.Text size={12} className={styles.infoItem}>*/}
      {/*    <ThumbUp className={styles.infoItemIcon} /> {news.likes}*/}
      {/*  </Typography.Text>*/}
      {/*)}*/}
    </span>
  );
};

const renderNews = (news: IHighlightedMaterial) => {
  const link = getMaterialLink(news, {
    rubricAlias: 'novosti',
  });
  return (
    <Link {...link} key={link.as}>
      <Typography.Link href={link.as} color={'black'}>
        <span className={styles.itemTitle}>{news.title}</span>
        {renderInfoBlock(news)}
      </Typography.Link>
    </Link>
  );
};

const renderMainNews = (news: IHighlightedMaterial, isMobile: boolean) => {
  if (!news) return null;

  const link = getMaterialLink(news, {
    rubricAlias: 'novosti',
  });

  const lead = news.lead ? trimHtml(news.lead, { limit: isMobile ? 300 : 60 }) : null;

  return (
    <Link {...link} key={link.as}>
      <Typography.Link href={link.as} color={'black'}>
        <Space direction={'vertical'} size={8} className={styles.mainItem}>
          <Badge color={'green'} variant={'primary'} text={'важное'} />

          <Typography.Heading level={isMobile ? 3 : 4} className={styles.mainItemTitle}>
            {news.title}
          </Typography.Heading>

          {lead && <Typography.Text size={14} color={'black'} dangerouslySetInnerHTML={{ __html: lead.html }} />}
          <Space>{renderInfoBlock(news)}</Space>
        </Space>
      </Typography.Link>
    </Link>
  );
};

export const NewsBlock: React.FC<Props> = ({ className }) => {
  const isMobile = useIsMobile();

  const { list, mainItem } = useSelector(getLatestNews);

  const newsLink = createLinkProps('list', LIST_BY_RUBRICS, {
    rubric: 'novosti',
  });

  return (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      size={isMobile ? 12 : 24}
      className={classNames(styles.card, className)}
    >
      {renderMainNews(mainItem, isMobile)}
      <Space direction={'vertical'}>
        <Space size={12} direction="vertical" className="h-mb-16 h-pt-8">
          {list.map(renderNews)}
        </Space>
        <Link {...newsLink}>
          <Typography.Link href={newsLink.as} strong>
            Все новости
          </Typography.Link>
        </Link>
      </Space>
    </Space>
  );
};
